import { Html5Qrcode } from 'html5-qrcode';

const SCANNER_CONTAINER_ID = 'web-qr-scanner-container';

/**
 * Abre un modal con escáner QR usando la cámara del navegador.
 * @returns {Promise<{ result: string }>} Promesa que resuelve con el valor del QR escaneado.
 */
export function scanQrWeb() {
  return new Promise((resolve, reject) => {
    // Crear overlay/modal
    const overlay = document.createElement('div');
    overlay.id = 'web-qr-scanner-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.85);z-index:99999;display:flex;flex-direction:column;align-items:center;justify-content:center;';

    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'background:#fff;border-radius:12px;padding:16px;width:320px;max-width:90vw;';

    const title = document.createElement('p');
    title.textContent = 'Escanear código QR';
    title.style.cssText = 'text-align:center;font-size:16px;font-weight:600;margin:0 0 12px;';

    const scannerDiv = document.createElement('div');
    scannerDiv.id = SCANNER_CONTAINER_ID;
    scannerDiv.style.cssText = 'width:100%;';

    const cancelBtn = document.createElement('button');
    cancelBtn.textContent = 'Cancelar';
    cancelBtn.style.cssText = 'margin-top:12px;width:100%;padding:10px;background:#e0e0e0;border:none;border-radius:8px;font-size:14px;cursor:pointer;';

    wrapper.appendChild(title);
    wrapper.appendChild(scannerDiv);
    wrapper.appendChild(cancelBtn);
    overlay.appendChild(wrapper);
    document.body.appendChild(overlay);

    const html5Qrcode = new Html5Qrcode(SCANNER_CONTAINER_ID);

    const cleanup = () => {
      html5Qrcode.stop().catch(() => {}).finally(() => {
        if (document.body.contains(overlay)) {
          document.body.removeChild(overlay);
        }
      });
    };

    html5Qrcode.start(
      { facingMode: 'environment' },
      { fps: 10, qrbox: { width: 250, height: 250 } },
      (decodedText) => {
        cleanup();
        resolve({ result: decodedText });
      },
      () => {
        // Error de frame individual — ignorar
      },
    ).catch((err) => {
      cleanup();
      reject(err);
    });

    cancelBtn.addEventListener('click', () => {
      cleanup();
      reject(new Error('QR scan cancelled by user'));
    });
  });
}
